import { OperatorsLicensesResponse } from '@/types/dde/operator'
import { FormattedOperator } from '@/types/operator'

export const getOperatorsForProperty = (
  property: string | string[],
  allOperatorsLicenses: OperatorsLicensesResponse,
  formattedOperators: FormattedOperator[]
): FormattedOperator[] => {
  if (property === 'all' || !allOperatorsLicenses || !allOperatorsLicenses.length) {
    return formattedOperators
  }

  const licensePropertyIndex = allOperatorsLicenses.findIndex(
    (licenseProperty) => licenseProperty.property === property
  )
  if (licensePropertyIndex === -1) {
    console.error(`License property: ${property} not found in getOperatorsLicenses`)
    return []
  }

  const licenseOperatorIds = allOperatorsLicenses[licensePropertyIndex].operators.map(
    ({ id }) => id
  )
  return formattedOperators.filter(({ id }) =>
    licenseOperatorIds.some((operatorId) => id === operatorId)
  )
}
